import React from "react";

import { IconAlertTriangle } from "@frontend/common";

import * as S from "./ReviewRequiredDescription.style";

const ReviewRequiredDescription = () => {
  return (
    <S.Wrapper>
      <IconAlertTriangle width={16} height={16} color="#7C899C" />
      <S.DescriptionText>
        This press will <S.FocusText>‘Not’</S.FocusText> be marked as
        <S.FocusText> ‘Unsuitable’</S.FocusText> automatically
      </S.DescriptionText>
    </S.Wrapper>
  );
};

export default ReviewRequiredDescription;
